import React from "react";
import Swiper, { Navigation, Pagination } from "swiper";
import { useContext, useEffect, useState } from "react";
import SimpleContext from "./../context/SimpleContext";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import { useHistory } from "react-router";

const SimpleSlider = ({ banner }) => {
  const context = useContext(SimpleContext);
  const history = useHistory();
  const [curr, setCurr] = useState(0);

  let slidess = [];
  context.offerBanners.map((i) =>
    slidess.push({ title: i.name, image: i.image })
  );

  useEffect(() => {
    Swiper.use([Navigation, Pagination]);
    new Swiper(".swiper-container", {
      float: "right",
      speed: 1000,
      direction: "horizontal",
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: true,
      },
    });
  }, []);

  const { length } = slidess;
  const goToNext = () => {
    setCurr(curr === length - 1 ? 0 : curr + 1);
  };

  const moveDot = (index) => {
    setCurr(index);
  };

  //رفتن به صفحه محصولات
  const goProduct = (searchBody, name) => {
    if (searchBody !== null && searchBody !== undefined) {
      context.setsearchProducts({});
      context.setjustFav(0);
      context.setsearchBodyOfProduct(searchBody);
      context.setpage(0);
      context.setheaderCat(name);
      context.setSelectedBrandsList(searchBody.brandIds);
      context.search(0, 0, 0, 0, 0, 0, 0, 0, 0, searchBody);
      context.categories(searchBody.categoryId, searchBody.brandIds);
      history.push("/CategoriesProducts");
    }
  };
  return (
    <>
      <div className="ProductSliderPlace">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            {banner.length > 0
              ? banner.map((i, j) => (
                  <div class="swiper-slide">
                    <img
                      onClick={() => goProduct(i.searchBody, i.title)}
                      key={j}
                      alt="عکس بنر"
                      src={i.image}
                      style={{
                        width: "95%",
                        maxwidth: "95%",
                        marginTop: "5%",
                        borderRadius: "15px",
                        display: "inline-block",
                      }}
                    />
                  </div>
                ))
              : null}
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </>
  );
};

export default SimpleSlider;
